import React from "react";
import { node, number, bool} from "prop-types";

const ToolbarItem = ({ startColumn, children, gridColumn }) => (
    // Make item start on row 1 column X, and span 1 rows and 3 columns:
    <div
        className="toolbar-item "
        style={{ gridArea: `1 / ${startColumn} / span 1 / ${gridColumn ? `span ${gridColumn}` : "span 3"}` }}>
        {children}
    </div>
);

ToolbarItem.propTypes = {
    children: node,
    startColumn: number.isRequired,
    gridColumn: bool,
};

ToolbarItem.defaultProps = {
    children: null,
    gridColumn: false,
};

export default ToolbarItem;
